'use strict';

var $strSlice = require('../helpers/callBound')('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};



//////////////////
// WEBPACK FOOTER
// ./~/_es-abstract@1.16.0@es-abstract/helpers/isPrefixOf.js
// module id = 514
// module chunks = 128